import { toggleAllBranches, toggleBranch } from '../lib/reportSchedules'
import type { Branch } from '../lib/types'
import { useStaffText } from '../ui/StaffText'
import { Tick } from './kit'

/** A letter's branches: All branches, then one tick per branch. */
export function BranchChecks({ branches, picked, onChange, labelledBy }: { branches: Branch[]; picked: string[]; onChange: (ids: string[]) => void; labelledBy: string }) {
  const { say } = useStaffText()
  const listed = branches.map((b) => b.id)
  const all = listed.length > 0 && listed.every((id) => picked.includes(id))
  return (
    <div className="rp-vlist rp-branchchecks" role="group" aria-labelledby={labelledBy}>
      {listed.length > 1 && (
        <Tick isSelected={all} onChange={() => onChange(toggleAllBranches(picked, listed))}>
          {say('pivot.allBranches')}
        </Tick>
      )}
      {branches.map((b) => (
        <Tick key={b.id} isSelected={picked.includes(b.id)} onChange={() => onChange(toggleBranch(picked, b.id, listed))}>
          {b.name}
        </Tick>
      ))}
    </div>
  )
}
